<template>
  <div class="auth">
    <div class="container">
      <div class="auth__wrapper">
        <login-form />
        <div class="auth__block">
          <p class="auth__block-title">{{ t('login.block.title') }}</p>
          <p class="auth__block-text">{{ t('login.block.text') }}</p>
          <router-link :to="translations.i18nRoute({ name: 'register' })" class="auth__block-button">{{ t('buttons.register') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import LoginForm from "@/components/forms/login-form.vue";
import translations from "@/core/helpers/translations.js";

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.auth {
  padding-block: 75px;

  &__wrapper {
    width: 80%;
    margin-inline: auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
  }

  &__block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &-title {
      color: #2F2F2F;
      text-align: center;
      font-size: 22px;
      font-weight: 600;
      line-height: 30.8px;
      text-transform: uppercase;
    }

    &-text {
      width: 475px;
      color: #5A5A5A;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 25.6px;
    }

    &-button {
      cursor: pointer;
      border-radius: 5px;
      background-color: #F7F7F7;
      padding: 12px 20px;
      width: fit-content;
      transition: 0.2s;

      color: #333;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 19px;
      text-transform: capitalize;

      @include hover {
        background-color: #d3d3d3;
      }
    }
  }
}

@media (max-width: 1100px) {
  .auth {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 50px;
    }
  }
}

@media (max-width: 550px) {
  .auth {
    &__block {
      &-text {
        width: 100%;
      }
    }
  }
}
</style>